export const getWindowInnerDimensions = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};